module.exports = __webpack_public_path__ + "img/idea_reality.3ec2a5c.webp";